let host = window.location.hostname
let server = "https://emfuom5ojj.execute-api.us-east-1.amazonaws.com/prod/poc"
module.exports = server